import { styled, Text } from '@a0/quantum-product';
import * as React from 'react';
import { ContentStyler } from '../../../../ContentRenderer';
var TermDefinitionItems = styled('li')({
    listStyle: 'none',
});
export var TermDefinition = function (_a) {
    var id = _a.id, title = _a.title, definition = _a.definition;
    return (React.createElement(TermDefinitionItems, null,
        React.createElement(Text, { variant: "h5", id: id }, title),
        React.createElement(ContentStyler, null,
            React.createElement(Text, { dangerouslySetInnerHTML: { __html: definition }, variant: "body1" }))));
};
